export const FMCG_META_DESCRIPTION =
  "Media monitoring and media analysis for FMCG brands across Southeast Europe - campaigns, share of voice, retailer coverage and crisis monitoring.";
